
import React from "react";
import { Box, Button } from "@mui/material";

const NAV_ITEMS = [
  { key: "live", label: "Live", icon: (active) => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill={active ? "#082D6B" : "none"} stroke={active ? "#082D6B" : "#9aa0b0"} strokeWidth="1.8">
      <rect x="2" y="3" width="15" height="13" rx="1"/>
      <path d="M17 8l5-3v10l-5-3V8z"/>
    </svg>
  )},
  { key: "history", label: "History", icon: (active) => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={active ? "#082D6B" : "#9aa0b0"} strokeWidth="1.8">
      <rect x="5" y="2" width="14" height="20" rx="1"/>
      <path d="M9 7h6M9 11h6M9 15h4"/>
    </svg>
  )},
  { key: "events", label: "Events", icon: (active) => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={active ? "#082D6B" : "#9aa0b0"} strokeWidth="1.8">
      <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/>
      <path d="M13.73 21a2 2 0 0 1-3.46 0"/>
    </svg>
  )},
  { key: "setting", label: "Setting", icon: (active) => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={active ? "#082D6B" : "#9aa0b0"} strokeWidth="1.8">
      <circle cx="12" cy="12" r="3"/>
      <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l-.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
    </svg>
  )},
  { key: "gallery", label: "Gallery", icon: (active) => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={active ? "#082D6B" : "#9aa0b0"} strokeWidth="1.8">
      <rect x="3" y="3" width="18" height="18" rx="2"/>
      <circle cx="8.5" cy="8.5" r="1.5"/>
      <path d="M21 15l-5-5L5 21"/>
    </svg>
  )},
];

const DeviceSidebar = ({ activeNav, setActiveNav }) => {
  return (
    <Box
      sx={{
        width: 72,
        flexShrink: 0,
        bgcolor: "#fff",
        borderRight: "1px solid #e8eaf0",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        pt: 1,
      }}
    >
      {NAV_ITEMS.map((item) => {
        const isActive = activeNav === item.key;
        return (
          <Button
            key={item.key}
            onClick={() => setActiveNav(item.key)}
            title={item.label}
            sx={{
              width: "100%",
              minHeight: 68,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              gap: 0.5,
              borderLeft: isActive ? "3px solid #082D6B" : "3px solid transparent",
              borderRadius: 0,
              color: isActive ? "#082D6B" : "#9aa0b0",
              "&:hover": {
                bgcolor: "rgba(8, 45, 107, 0.04)",
              },
            }}
          >
            {item.icon(isActive)}
            <Box
              component="span"
              sx={{
                fontSize: 10,
                fontWeight: isActive ? 700 : 500,
                lineHeight: 1,
              }}
            >
              {item.label}
            </Box>
          </Button>
        );
      })}
    </Box>
  );
};

export default DeviceSidebar;